import { routeList } from '@/router/helpers/routes'

/* Mapping Favorites Tabs from label */
export const favoritesTabsMapper = label => {
    const favoritesTabs = {
        1: 'Transfers',
        2: 'Payments',
        3: 'SmartTransfer',
        4: 'Cards',
        5: 'Withdrawals',
		6: 'Transfers'
    }
    return favoritesTabs[label]
}

/* Mapping Favorite Routes */
export const getFavoriteRoute = operationTypeId => {
	let route = ''

	switch (operationTypeId) {
	case 74:
	case 75:
		route = routeList.TRANSFERS_NACIONAL_NAME
		break
	case 76:
    case 36004:
		route = routeList.TRANSFERS_INTERNATIONAL_NAME
		break
    case 36017:
        route = routeList.TRANSFERS_INSTANT_BAI_NAME
        break
	case 5004:
		route = routeList.CARDS_TRANSFERS_FLEX_NAME
		break
	case 70000:
		route = routeList.PAYMENTS_WALLET_NAME
		break
	case 19001:
	case 19002:
	case 19003:
	case 19004:
	case 31002:
	case 35002:
	case 35004:
	case 35008:
	case 35023:
	case 21002:
	case 22028:
	case 22031:
	case 35018:
	case 35021:
		route = routeList.PAYMENTS_SERVICES_NAME
		break
	case 32009:
		route = routeList.TRANSFERS_NACIONAL_NAME
		break
	case 32003:
		route = routeList.TRANSFERS_REQUEST_NAHORA_NAME
		break
	case 5000:
		route = routeList.CARDS_CHARGE_FLEX_NAME
		break
	case 19102:
		route = routeList.CARDS_CARDLESS_WITHDRAW_GENERATE_CODE_NAME
		break
	case 500016:
		route = routeList.CARDS_CHARGE_FLEX_NAME
		break
	}
	return route
}
